import{resolveAsset}from'../utils/assets'
export const adaptBanners=list=>(list||[]).map((raw,i)=>({id:raw.id||raw.uuid||i,image:resolveAsset(raw.imgUrl||raw.image||raw.bannerUrl,'banner',i),link:raw.link||'',title:raw.title||''}))
